import React, { Component } from 'react';
import { isEmpty, handleDownloadCSV } from '../../Common/Common';
import Calendar from '../../Part_Sample/Calendar';
import Top_Bar from '../../Part_Sample/Top_Bar';

import Err_Info_Display_Row from './Err_Info_Display_Row';
import {
	getMonthSelect, getYearSelect, getYearSelectWithStartDate, getChartMonthSelect, getMonthEndDate,
	getDefaultMonth
} from '../util/util';
import { navigateReport } from '../../Common/navigation';

export default class Error_Info_Report extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		let tab = 'day';
		let err_info = {};
		if (this.props.param.err_info != null) err_info = this.props.param.err_info;

		let selected_date = new Date();
		if (this.props.param.search_date != null) selected_date = this.props.param.search_date;

		let selected_month = selected_date.getMonth();
		let selected_year = selected_date.getFullYear();

		// Default month 
		selected_month = getDefaultMonth(this.props.param.report_settings, selected_year, selected_month)

		this.state = {
			tab: tab,
			err_info: err_info,

			is_show_calendar: false,
			selected_date: selected_date,

			selected_month: selected_month,
			m_selected_year: selected_year,
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		if (this.props.param.from == 'Layout') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			window.app.receiver.stored_params.layout_id = this.props.param.layout_id;
			window.app.receiver.next_component = 'Layout';
			window.app.receiver.getGroups();
		} else {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			navigateReport("null");
		}
	}

	handleShow = (key) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({ tab: key }, this.handleQuery)
	}

	toggleCalendar = () => {
		this.setState({ is_show_calendar: !this.state.is_show_calendar })
	}

	handleChangeCalDate = (selected_date) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({
			selected_date: selected_date,
			is_show_calendar: false
		}, this.handleQuery);
	}

	handleChangeYear = (year) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({
			m_selected_year: year
		}, this.handleQuery);
	}

	handleChangeMonth = (month) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({
			selected_month: month
		}, this.handleQuery);
	}

	handleQuery = () => {
		window.app.showLoading();
		let points = Object.keys(window.app.state.point_list);
		let start_date = new Date();
		let end_date = new Date();

		if (this.state.tab == 'day') {
			let search_details = {
				year: this.state.selected_date.getFullYear(),
				month: this.state.selected_date.getMonth() + 1,
				day: this.state.selected_date.getDate(),
			}

			this.props.receiver.getDailyErrorInfo(search_details);
		} else if (this.state.tab == 'month') {
			// Check for report_settings start_date/month
			let date = 1;
			if (!isEmpty(this.props.param.report_settings)) {
				if (this.props.param.report_settings.start_day != null) date = this.props.param.report_settings.start_day;
			}

			start_date.setYear(this.state.m_selected_year);
			start_date.setMonth(this.state.selected_month);
			start_date.setDate(date);
			end_date = getMonthEndDate(start_date);

			// DB time end date is 0000 hours, so must add 1
			end_date.setDate(end_date.getDate() + 1);

			if (start_date.getMonth() > this.state.selected_month) {
				start_date.setDate(1);
			}

			// search_details = {"fy":year,"fm":month,"fd":day,"ty":year,"tm":month,"td":day,"points":[point id]}
			let search_details = {
				fy: start_date.getFullYear(),
				fm: start_date.getMonth() + 1,
				fd: start_date.getDate(),
				ty: end_date.getFullYear(),
				tm: end_date.getMonth() + 1,
				td: end_date.getDate(),
			}
			this.props.receiver.getMonthlyErrorInfo(search_details);

		}
	}

	rcvDailyErrorInfo = (daily_err_info) => {
		this.lastClickTime = false;
		window.app.hideLoading();
		this.setState({ err_info: daily_err_info });
	}

	rcvMonthlyErrorInfo = (monthly_err_info) => {
		this.lastClickTime = false;
		window.app.hideLoading();
		this.setState({ err_info: monthly_err_info });
	}

	// Save as csv
	handleLeftButtonAction = () => {

		let Today = new Date();
		let file_name = "Malfunction_Data_Report_" + Today.getFullYear()
			+ (Today.getMonth() < 10 ? '0' : '') + (Today.getMonth() + 1)
			+ (Today.getDate() < 10 ? '0' : '') + (Today.getDate())
			+ '.csv';

		let csv = [];
		let err_data = this.state.err_info.data;
		Object.keys(err_data).map((key) => {
			let point_info = window.app.state.point_list[key];
			if (!isEmpty(point_info)) {
				let name = point_info.name;
				let obj = err_data[key];
				Object.keys(obj).map((mp_key) => {
					let row = [];
					row.push(name); //management point name
					row.push(mp_key); //error type
					row.push(obj[mp_key]); //total number of errors
					csv.push(row.join(","));
				})
			}
		})
		handleDownloadCSV(csv.join("\n"), file_name);
	}

	render() {
		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - 60,
			overflow: 'auto',
		}

		let max_height = this.props.height - 270;
		if (is_landscape) {
			max_height = this.props.height - 60;
			// 400px = height of Top bar + Date Selection + table header and 1st row 
			if (max_height > 400) max_height = this.props.height - 270;
		}

		let table_style = {
			borderLeft: '2px solid rgb(139 139 139)',
			borderTop: '2px solid rgb(139 139 139)',
			width: this.props.width - 40,
			maxHeight: max_height,
			overflow: 'auto',
			overflowX: 'hidden',
			marginLeft: 20,
		}

		let row_style = {
			textAlign: 'left',
		}

		let header_cell_height = 'unset';
		if (((this.props.width - 40) / 4 - 20 - 2) < 158) header_cell_height = 80;

		let table_cell_style1 = {
			padding: 10,
			backgroundColor: 'white',
			width: (this.props.width - 40) / 2 - 20 - 2, // -20 for padding, -2 for border
			borderRight: '2px solid rgb(139 139 139)',
			borderBottom: '2px solid rgb(139 139 139)',
			display: 'inline-block',
			verticalAlign: 'top',
			height: header_cell_height,
		}

		let table_cell_style2 = {
			padding: 10,
			backgroundColor: 'white',
			display: 'inline-block',
			width: (this.props.width - 40) / 4 - 20 - 2, // -20 for padding, -2 for border
			borderRight: '2px solid rgb(139 139 139)',
			borderBottom: '2px solid rgb(139 139 139)',
			verticalAlign: 'top',
			height: header_cell_height,
		}

		let table_cell_style3 = {
			padding: 10,
			backgroundColor: 'white',
			width: (this.props.width - 40) / 2 - 20 - 2, // -20 for padding, -2 for border
			borderBottom: '2px solid rgb(139 139 139)',
			display: 'inline-block',
			verticalAlign: 'bottom'
		}

		let table_cell_style4 = {
			padding: 10,
			backgroundColor: 'white',
			display: 'inline-block',
			width: (this.props.width - 40) / 4 - 20 - 2, // -20 for padding, -2 for border
			borderLeft: '2px solid rgb(139 139 139)',
			borderRight: '2px solid rgb(139 139 139)',
			borderBottom: '2px solid rgb(139 139 139)',
		}

		let table_cell_style5 = {
			padding: 10,
			backgroundColor: 'white',
			display: 'inline-block',
			width: (this.props.width - 40) / 4 - 20 - 2, // -20 for padding, -2 for border
			borderRight: '2px solid rgb(139 139 139)',
			borderBottom: '2px solid rgb(139 139 139)',
			verticalAlign: 'top',
		}

		let select_style = {
			height: 30,
			textAlign: 'center',
			border: 'none',
			background: 'none',
			borderBottom: '1px solid' + this.props.colours.appBlue,
			outline: 'none',
			verticalAlign: 'top',
			cursor: 'pointer',
			display: 'inline-block',
			marginLeft: 10,
		}

		let content_height = 100;

		let cal_width = is_landscape ? this.props.width - 100 : this.props.width - 40;
		let cal_height = 200;

		// Check for report_settings start_date/month
		let start_date = 1;
		let start_month = 0;
		if (!isEmpty(this.props.param.report_settings)) {
			if (this.props.param.report_settings.start_day != null) start_date = this.props.param.report_settings.start_day;
			if (this.props.param.report_settings.start_month != null) start_month = this.props.param.report_settings.start_month;
		}

		let months_range = getChartMonthSelect(start_date, this.state.m_selected_year);
		let m_years_range = getYearSelect(2);

		let years_range = getYearSelectWithStartDate(2, start_month, start_date);

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('err_reporting_report')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 10, verticalAlign: 'bottom', width: this.props.width, opacity: 0.95 }}>
						<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'day' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'day' ? 'white' : 'black' }} onClick={() => this.handleShow('day')}>{this.props.receiver.getString('day')}</span>
						<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'month' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'month' ? 'white' : 'black' }} onClick={() => this.handleShow('month')}>{this.props.receiver.getString('month')}</span>
					</div>
					<div>
						{(() => {
							switch (this.state.tab) {
								case 'day':
									return (
										<div style={{ width: '100%', height: content_height }}>
											<div onClick={this.toggleCalendar} style={{ cursor: 'pointer', paddingTop: 20, paddingLeft: 20, textAlign: 'left' }}>
												<span className='title'>{this.props.receiver.getString('date')
													+ ': ' + this.state.selected_date.toLocaleDateString()}</span>
											</div>
											<div className='slideInDown' style={{}}>
												<Calendar
													onSelect={this.handleChangeCalDate}
													style={{ visibility: this.state.is_show_calendar ? 'visible' : 'hidden' }}
													width={cal_width}
													height={cal_height}
													left={(this.props.width - 20) * 0.05}
													max_date={new Date()}
													selected_date={this.state.selected_date}
												/>
											</div>
										</div>
									);
									break;
								case 'month':
									return (
										<div style={{ width: '100%', height: content_height }}>
											<div style={{ paddingTop: 20, paddingLeft: 20, textAlign: 'left' }}>
												<span className='subtitle' style={{ fontSize: 20, display: 'inline-block', padding: 0, paddingLeft: 10 }}>{this.props.receiver.getString('year')}: </span>
												<select value={this.state.m_selected_year} style={select_style} onChange={(event) => this.handleChangeYear(event.target.value)}>
													{m_years_range}
												</select>
											</div>
											<div style={{ paddingLeft: 20, textAlign: 'left' }}>
												<span className='subtitle' style={{ fontSize: 20, display: 'inline-block', padding: 0, paddingLeft: 10 }}>{this.props.receiver.getString('month')}: </span>
												<select value={this.state.selected_month} style={select_style} onChange={(event) => this.handleChangeMonth(event.target.value)}>
													{months_range}
												</select>
											</div>
										</div>
									);
									break;
								default:
									return (
										<div></div>
									);
							}
						})()}
					</div>

					<div style={table_style} className='noScrollBar'>
						<div style={row_style}>
							<div style={table_cell_style1}>
								<span >{this.props.receiver.getString('device')}</span>
							</div>
							<div style={table_cell_style2}>
								<span>{this.props.receiver.getString('err_code')}</span>
							</div>
							<div style={table_cell_style2}>
								<span>{this.props.receiver.getString('err_code_freq')}</span>
							</div>
						</div>
						{Object.keys(this.state.err_info.data).map((point_id) => {
							let point_info = window.app.state.point_list[point_id];
							let data = this.state.err_info.data[point_id];

							if (isEmpty(point_info)) point_info = { name: point_id }

							// Check if object contains no error code
							if (Object.keys(this.state.err_info.data[point_id]).length == 0) {
								return null;
							} else {
								return (
									<Err_Info_Display_Row
										key={point_info.name}
										point_info={point_info}
										data={data}
										receiver={this.props.receiver}
										row_style={row_style}
										cell_style={table_cell_style1}
										cell_style0={table_cell_style2}
										cell_style1={table_cell_style3}
										cell_style2={table_cell_style4}
										cell_style3={table_cell_style5}
									/>
								)
							}
						})}
					</div>
				</div>
			</div>
		)
	}
}